import React from 'react';
import { Navigate } from 'react-router-dom';
import Box from '@cloudscape-design/components/box';
import Spinner from '@cloudscape-design/components/spinner';
import { useAuth } from './AuthProvider';

/** Gates protected routes: shows a spinner while resolving, redirects to /login if signed out. */
const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box textAlign="center" padding="xxxl">
        <Spinner size="large" />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isAdmin) {
    return (
      <Box textAlign="center" padding="xxxl">
        You don&apos;t have access to the Fly-in Spotter admin console.
      </Box>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
